function fetchConfig(type = 'json') {
	return {
		method: 'POST',
		headers: {'Content-Type': 'application/json', 'Accept': `application/${type}`}
	};
}

function debounce(fn, delay) {
	let timeoutId;
	return function (...args) {
		clearTimeout(timeoutId);
		timeoutId = setTimeout(() => fn.apply(this, args), delay);
	};
}

// Product recommendation

if (!customElements.get('product-recommendation')) {
	customElements.define('product-recommendation', class ProductRecommendation extends HTMLElement {
		constructor() {
			super();
			this.renderSection();
			this.slider = this.querySelector('.js-other-products-slider');
		}

		async renderSection() {
			try {
				const response = await fetch(this.dataset.url);
				const responseText = await response.text();
				const doc = new DOMParser().parseFromString(responseText, 'text/html');

				const fetchSection = doc.querySelector('[data-product-list]');
				const section = this.querySelector('[data-product-list]');

				if (fetchSection?.innerHTML.trim() && section) {
					section.innerHTML = fetchSection.innerHTML;
					this.removeAttribute('style');
				}
				initSectionSliderOtherProduct(this.slider);
				updateProductForm()

			} catch (err) {
				console.error('Failed to load product recommendations:', err);
			}
		}
	});
}

function initSectionSliderOtherProduct(container) {
	const $container = $(container);
	const swiper = new Swiper(container, {
		loop: false,
		speed: 1000,
		slidesPerView: 1,
		easing: 'cubic-bezier(0.23, 1, 0.32, 1)',
		navigation: {
			enabled: false,
			nextEl: container.querySelector('.swiper-button-next'),
			prevEl: container.querySelector('.swiper-button-prev')
		},
		breakpoints: {
			768: {
				slidesPerView: 2
			},
			992: {
				slidesPerView: 3
			},
			1200: {
				slidesPerView: 4
			}
		},
		resistance: false,
		freeMode: false,
		touchRatio: 1,
		touchAngle: 45,
		longSwipesRatio: 0.5,
		watchOverflow: true,
		normalizeSlideIndex: true
	});
	$container.addClass('show');
}
if ($('.js-other-products-slider').length) {
	$('.js-other-products-slider').each(function () {
		if (this.offsetParent !== null) {
			setTimeout(() => initSectionSliderOtherProduct(this), 50);
		}
	});
}

// Update product forms
function getConfig(field) {
	return {
		min: parseInt(field.dataset.min, 10),
		max: parseInt(field.dataset.max, 10),
		prefix: field.dataset.prefix || '',
		postfix: field.dataset.postfix ? ' ' + field.dataset.postfix : ''
	};
}

function getNum(val) {
	if (typeof val !== 'string') val = String(val || '');
	const match = val.match(/-?\d+\.?\d*/);
	return match ? parseInt(match[0], 10) : '';
}

function syncState(countEl) {
	const field = countEl.querySelector('.count-value');
	const inc = countEl.querySelector('.count-inc');
	const dec = countEl.querySelector('.count-dec');
	if (!field) return;

	const { min, max } = getConfig(field);
	let value = getNum(field.value);

	inc?.classList.remove('disabled');
	dec?.classList.remove('disabled');

	if (value <= min) dec?.classList.add('disabled');
	if (value >= max) inc?.classList.add('disabled');

	setWidthField(field);
}

function ensureInit(countEl) {
	if (!countEl || countEl.dataset.countInit === '1') return;
	countEl.dataset.countInit = '1';
	syncState(countEl);
}

function initCountsInDom(root = document) {
	root.querySelectorAll('.count').forEach(countEl => {
		ensureInit(countEl);
	});
}

window.setCountValue = function(field, value) {
	if (!field) return;
	const countEl = field.closest('.count');
	if (!countEl) return;

	ensureInit(countEl);
	const { min, max, prefix, postfix } = getConfig(field);
	value = Math.max(min, Math.min(max, value));
	field.value = prefix + value + postfix;
	syncState(countEl);
};

function syncCountsWithCart(cart) {
	const cartMap = {};
	cart.items.forEach(item => {
		cartMap[item.id] = item.quantity;
	});
	const updatedIds = new Set();

	cart.items.forEach(item => {
		const productId = Number(item.id);
		const forms = document.querySelectorAll(`product-form[data-id="${productId}"]`);
		if (!forms.length) return;
		forms.forEach(formEl => {
			const countField = formEl.querySelector('.count-value');
			const form = formEl.querySelector('form');
			if (!countField) return;

			form?.classList.add('active');
			formEl.classList.add('active');
			window.setCountValue(countField, cartMap[productId]);
		});
		updatedIds.add(productId);
	});

	document.querySelectorAll('product-form.active').forEach(formEl => {
		const productId = Number(formEl.dataset.id);
		if (updatedIds.has(productId)) return;
		const countField = formEl.querySelector('.count-value');
		const form = formEl.querySelector('form');
		if (!countField) return;

		form?.classList.remove('active');
		formEl.classList.remove('active');
		window.setCountValue(countField, 1);
	});
}

function updateHeaderCartCount(count) {
	const countEl = document.querySelector('.header-cart__count');
	if (!countEl) return;
	const safeCount = Number.isFinite(Number(count)) ? Number(count) : 0;
	countEl.textContent = safeCount;
	countEl.style.display = safeCount > 0 ? '' : 'none';
}

function setWidthField(field) {
	if (!field) return;
	if (!field._padding) {
		const styles = getComputedStyle(field);
		field._padding =
			(parseFloat(styles.paddingLeft) || 0) +
			(parseFloat(styles.paddingRight) || 0);
	}
	const value = field.value || '';
	const symbolCount = value.length;
	const widthPx = symbolCount * 10 - symbolCount + 1 + field._padding;
	field.style.width = `${widthPx / 16}rem`;
}
async function updateProductForm() {
	try {
		const response = await fetch('/cart.js');
		if (!response.ok) {
			throw new Error(`HTTP error! status: ${response.status}`);
		}

		const cart = await response.json();
		syncCountsWithCart(cart);
		updateHeaderCartCount(cart.item_count);

	} catch (error) {
		console.error('Failed to update cart count:', error);
	}
}

//  Cart popup
async function updateCartPopup(openPopup = false) {
	try {
		const currentModalBefore = document.querySelector('.header-cart__modal');
		const wasOpen = currentModalBefore?.classList.contains('show');
		const overlayBefore = document.querySelector('.cart-overflow');
		const overlayWasOpen = overlayBefore?.classList.contains('show');
		const response = await fetch(`${window.routes.cart_url}?section_id=cart-popup`);
		const html = await response.text();
		const parser = new DOMParser();
		const doc = parser.parseFromString(html, 'text/html');
		const fetchedModal = doc.querySelector('.header-cart__modal');
		const currentModal = document.querySelector('.header-cart__modal');
		if (!fetchedModal || !currentModal) return;

		const fetchedCount = fetchedModal.querySelector('.header-cart__count');
		if (fetchedCount) {
			updateHeaderCartCount(fetchedCount.textContent);
		}

		const fetchedItems = fetchedModal.querySelectorAll('popup-cart-item[data-item-index]');
		const currentItems = currentModal.querySelectorAll('popup-cart-item[data-item-index]');

		if (fetchedItems.length === 0) {
			currentModal.outerHTML = fetchedModal.outerHTML;
		} else if (currentItems.length === 0) {
			currentModal.outerHTML = fetchedModal.outerHTML;
		} else {
			const fetchedMap = new Map();
			fetchedItems.forEach(item => {
				fetchedMap.set(item.dataset.itemIndex, item);
			});

			const currentMap = new Map();
			currentItems.forEach(item => {
				currentMap.set(item.dataset.itemIndex, item);
			});

			fetchedItems.forEach(fetchedItem => {
				const key = fetchedItem.dataset.itemIndex;
				const currentItem = currentMap.get(key);
				if (currentItem) {
					currentItem.outerHTML = fetchedItem.outerHTML;
				} else {
					const currentForm = currentModal.querySelector('.header-cart__modal-content form');
					const fetchedForm = fetchedModal.querySelector('.header-cart__modal-content form');
					if (currentForm && fetchedForm) {
						currentForm.insertAdjacentHTML('beforeend', fetchedItem.outerHTML);
					}
				}
			});

			currentItems.forEach(currentItem => {
				if (!fetchedMap.has(currentItem.dataset.itemIndex)) {
					currentItem.remove();
				}
			});

			const fetchedFoot = fetchedModal.querySelector('.header-cart__modal-foot');
			const currentFoot = currentModal.querySelector('.header-cart__modal-foot');
			if (fetchedFoot && currentFoot) {
				currentFoot.outerHTML = fetchedFoot.outerHTML;
			}

			const fetchedHead = fetchedModal.querySelector('.header-cart__modal-head');
			const currentHead = currentModal.querySelector('.header-cart__modal-head');
			if (fetchedHead && currentHead) {
				currentHead.outerHTML = fetchedHead.outerHTML;
			}
		}
		// Refresh every delivery-progress instance on the page — the popup's
		// (in the partial-update path) and the product-page copy — from the
		// freshly rendered section.
		const fetchedBar = fetchedModal.querySelector('.cart-progress-bar-container');
		if (fetchedBar) {
			document.querySelectorAll('.cart-progress-bar-container').forEach(el => {
				el.outerHTML = fetchedBar.outerHTML;
			});
		}
		updateCartPopupEvents(openPopup || wasOpen || overlayWasOpen);
		initCountsInDom(document.querySelector('#cart-popup'));
		// Sync product-form steppers from the section we already fetched —
		// item variant ids and quantities are in the popup markup — instead
		// of a second /cart.js round trip per cart interaction.
		const itemsFromSection = Array.from(fetchedModal.querySelectorAll('popup-cart-item[data-item-index]')).map(el => ({
			id: Number(el.dataset.itemIndex),
			quantity: parseInt((el.querySelector('.count-value')?.value || '').replace(/[^0-9]/g, ''), 10) || 0
		}));
		syncCountsWithCart({ items: itemsFromSection });

	} catch (error) {
		console.error('Cart popup content update error:', error);
	}
}

// Update cart popup events
function updateCartPopupDetails() {
	// Namespaced so repeated cart refreshes replace the handler instead of
	// stacking a new one each time (toggles fired N times after N refreshes).
	$(".js-header-cart-details-toggle").off("click.fdCartDetails").on("click.fdCartDetails", function (e) {
		e.preventDefault();
		const $this = $(this);
		const $parent = $this.closest(".header-cart__details");
		const textShow = $this.attr("data-text-show");
		const textHide = $this.attr("data-text-hide");
		if (!$parent.hasClass("show")) {
			$this.find("span:not(.icon)").text(textHide);
			$parent.addClass("show");
			$parent.find(".header-cart__details-table").slideDown(600);
		} else {
			$this.find("span:not(.icon)").text(textShow);
			$parent.removeClass("show");
			$parent.find(".header-cart__details-table").slideUp(600);
		}
	});

	// Scope to the popup's own (freshly rendered) scrollbars — this ran over
	// every .js-scrollbar on the page on each cart refresh, re-initializing
	// scrollbars in unrelated menus.
	$("#cart-popup .js-scrollbar").each(function () {
		const $el = $(this);
		if ($el.data("scrollbarInit") === 1) return;
		$el.data("scrollbarInit", 1);
		$el.mCustomScrollbar({
			scrollButtons: {
				enable: false,
			},
			autoHideScrollbar: false,
			scrollInertia: 600,
			mouseWheel: {
				enable: true,
				scrollAmount: 100,
			},
			keyboard: {
				enable: true,
			},
			advanced: {
				updateOnContentResize: true,
			},
		});
	});
}

function updateCartPopupEvents(openPopup = false){
	let popup = document.querySelector('#cart-popup');
	let popupClose = document.querySelector('#cart-popup .js-header-cart-close');
	let popupOverlay = document.querySelector('.cart-overflow');
	let headerOverlay = document.querySelector('.header-overflow');
	let body = document.body;

	const headerOverlayActive = headerOverlay?.classList.contains('show');
	const isAlreadyOpen = (popupOverlay && popupOverlay.classList.contains('show')) || body.classList.contains('no-scroll');

	if (openPopup && isAlreadyOpen) {
		if (popup) popup.classList.add('show');
		if (!headerOverlayActive && popupOverlay) popupOverlay.classList.add('show');
		body.classList.add('no-scroll');
	}

	const closeCart = function(e) {
		if(e) e.preventDefault();

		if(popup) popup.classList.remove('show');
		if(popupOverlay) popupOverlay.classList.remove('show');
		if(headerOverlay) headerOverlay.classList.remove('show');
		body.classList.remove('no-scroll');
	};

	if (popupClose) {
		popupClose.onclick = closeCart;
	}

	if (popupOverlay) {
		popupOverlay.onclick = closeCart;
	}
	if (headerOverlay) {
		headerOverlay.onclick = closeCart;
	}
	if(typeof updateCartPopupDetails === 'function') {
		updateCartPopupDetails();
	}
}

// Update filter popup events

/* - - - - - - - - - - - - - -       toggle subcategory search       - - - - - - - - - - - - - - - */
$('.js-subcategory-search').on('click', function(e) {
	e.preventDefault();
	$(this).closest('.catalog-subcategory').addClass('is-search');
});
$(document).on('click', (e) => {
	if (!$(e.target).closest('.catalog-subcategory').length) {
		$('.catalog-subcategory').removeClass('is-search');
	}
});

function updateFilterState() {

	$(".js-catalog-filter-open").on("click", function (e) {
		e.preventDefault();
		$(".catalog-filter__modal").addClass("show");
		$(".overflow").addClass("show");
		$("body").addClass("no-scroll");
	});

	const $accordions = $(".catalog-filter__accordion");
	$accordions.each(function () {
		const $parent = $(this);
		const $content = $parent.find(".catalog-filter__accordion-content");

		if ($parent.hasClass("show")) {
			$content.css("display", "block");

		} else {
			$content.stop(true, true).slideUp(600);
		}
	});

	$(".js-catalog-filter-group-reset").on("click", function (e) {
		e.preventDefault();
		e.stopPropagation();

		const $accordion = $(this).closest(".catalog-filter__accordion");
		const $form = $(this).closest("form");
		$accordion.removeClass("filtered");
		$accordion.find('[type="checkbox"], [type="radio"]').prop("checked", false);
		const productFilter = document.querySelector("product-filter");
		if (productFilter) {
			const fakeEvent = new Event("input", { bubbles: true });
			$form[0].dispatchEvent(fakeEvent);
		}
	});

	$(".catalog-filter__modal-box form").on("reset", function (e) {
		e.preventDefault();

		const $form = $(this);
		const productFilter = document.querySelector("product-filter");
		$form.find('input[type="checkbox"], input[type="radio"]').prop("checked", false);

		const minPrice = $form.find("#minPrice");
		const maxPrice = $form.find("#maxPrice");
		if (minPrice.length && maxPrice.length) {
			minPrice.val(minPrice.attr("min") || minPrice.prop("defaultValue"));
			maxPrice.val(maxPrice.attr("max") || maxPrice.prop("defaultValue"));
		}
		$form.find(".catalog-filter__accordion")
			.removeClass("filtered show");

		$form.find(".catalog-filter__accordion-content").each(function () {
			$(this).slideUp(300);
		});
		if (productFilter) {
			const fakeEvent = new Event("input", { bubbles: true });
			productFilter.form.dispatchEvent(fakeEvent);
		}
	});
}

updateFilterState();

function initIonRangeSlider(scope = document) {
	const ranges = scope.querySelectorAll('.js-range');
	const safePrettify = (num) => {
		if (typeof prettify === 'function') return prettify(num);
		return num;
	};

	ranges.forEach(rangeEl => {
		const $range = $(rangeEl);
		if ($range.data('ionRangeSlider')) return;

		const parent = rangeEl.closest('.range-box');
		if (!parent) return;

		const inputFrom = parent.querySelector('.range-box__value-from');
		const inputTo = parent.querySelector('.range-box__value-to');

		const form = rangeEl.closest('form');

		const min = parseInt(rangeEl.dataset.min, 10);
		const max = parseInt(rangeEl.dataset.max, 10);
		const from = parseInt(rangeEl.dataset.from, 10);
		const to = parseInt(rangeEl.dataset.to, 10);

		let instance = null;

		function updateInputs(data) {
			if (!inputFrom || !inputTo) return;
			inputFrom.value = safePrettify(data.from);
			inputTo.value = safePrettify(data.to);
		}

		function triggerFormSubmit() {
			if (form) {
				form.dispatchEvent(new Event("input", { bubbles: true }));
			}
		}

		$range.ionRangeSlider({
			type: 'double',
			grid: false,
			hide_from_to: true,
			hide_min_max: true,
			min,
			max,
			from,
			to,
			onStart: updateInputs,
			onChange: updateInputs,
			onFinish: function(data) {
				updateInputs(data);
				triggerFormSubmit();
			}
		});

		instance = $range.data('ionRangeSlider');
		if (!instance) return;

		let debounceTimer;
		function handleInputChange() {
			clearTimeout(debounceTimer);
			debounceTimer = setTimeout(() => {
				triggerFormSubmit();
			}, 800);
		}

		if (inputFrom) {
			inputFrom.addEventListener('change', () => {
				let val = parseInt(inputFrom.value.replace(/\D+/g, ''), 10);
				if (isNaN(val)) val = min;
				const currentTo = parseInt(inputTo.value.replace(/\D+/g, ''), 10);
				val = Math.max(min, Math.min(val, currentTo));

				instance.update({ from: val });
				inputFrom.value = safePrettify(val);

				triggerFormSubmit();
			});
		}

		if (inputTo) {
			inputTo.addEventListener('change', () => {
				let val = parseInt(inputTo.value.replace(/\D+/g, ''), 10);
				if (isNaN(val)) val = max;
				const currentFrom = parseInt(inputFrom.value.replace(/\D+/g, ''), 10);
				val = Math.min(max, Math.max(val, currentFrom));

				instance.update({ to: val });
				inputTo.value = safePrettify(val);

				triggerFormSubmit();
			});
		}
	});
}

// Article related products

function initArticleLoadMore() {
	const btn = document.querySelector(".js-load-products");
	const products = document.querySelectorAll(".article-product__grid .product-card");

	if (!btn || !products.length) return;

	if (btn.dataset.initialized === "true") return;

	const chunkSize = 4;
	let visibleCount = 4;
	const total = products.length;

	// Функція анімації
	function animateFade(el, show) {
		el.style.transition = "opacity 0.25s ease";

		if (show) {
			el.style.opacity = 0;
			el.classList.remove("hidden");

			setTimeout(() => {
				requestAnimationFrame(() => {
					el.style.opacity = 1;
				});
			}, 50);

		} else {
			el.style.opacity = 1;
			requestAnimationFrame(() => {
				el.style.opacity = 0;
			});

			setTimeout(() => {
				el.classList.add("hidden");
				scrollToButton();
			}, 250);
		}
	}

	function scrollToButton() {
		requestAnimationFrame(() => {
			requestAnimationFrame(() => {
				btn.scrollIntoView({
					behavior: "smooth",
					block: "center"
				});
			});
		});
	}

	function renderVisibility() {
		products.forEach((product, index) => {
			const shouldShow = index < visibleCount;

			// Показуємо, якщо ще сховано
			if (shouldShow && product.classList.contains("hidden")) {
				animateFade(product, true);
			}
			else if (!shouldShow && !product.classList.contains("hidden")) {
				animateFade(product, false);
			}
		});

		// Оновлення тексту кнопки
		const btnSpan = btn.querySelector("span");
		if (btnSpan) {
			if (visibleCount >= total) {
				btnSpan.innerText = btn.dataset.loadLess || 'Load Less';
			} else {
				btnSpan.innerText = btn.dataset.loadMore || 'Load More';
			}
		}
	}

	btn.addEventListener("click", function (e) {
		e.preventDefault();

		if (visibleCount >= total) {
			visibleCount = chunkSize;
			scrollToButton();
		} else {
			visibleCount += chunkSize;
		}

		renderVisibility();
	});

	renderVisibility();

	btn.dataset.initialized = "true";
}

if (document.readyState === 'loading') {
	document.addEventListener("DOMContentLoaded", initArticleLoadMore);
} else {
	initArticleLoadMore();
}

document.addEventListener('click', function(e) {
	const openBtn = e.target.closest('.js-header-cart-open');

	const closeBtn = e.target.closest('.js-header-cart-close');
	const overflow = e.target.closest('.header-overflow');

	if (openBtn) {
		e.preventDefault();
		const cartPopup = document.getElementById('cart-popup');
		const headerOverflow = document.querySelector('.header-overflow');

		if (cartPopup) cartPopup.classList.add('show');
		if (headerOverflow) headerOverflow.classList.add('show');
		document.body.classList.add('no-scroll');
	}

	if (closeBtn || (overflow && overflow.classList.contains('show'))) {
		e.preventDefault();
		const cartPopup = document.getElementById('cart-popup');
		const headerOverflow = document.querySelector('.header-overflow');

		if (cartPopup) cartPopup.classList.remove('show');
		if (headerOverflow) headerOverflow.classList.remove('show');
		document.body.classList.remove('no-scroll');
	}
});
